import { Badge } from "@tellescope/ui";

export interface TeamMemberBadgeListProps {
  values: string[];
  emptyLabel: string;
}

export const TeamMemberBadgeList = ({ values, emptyLabel }: TeamMemberBadgeListProps) => (
  <div className="flex flex-nowrap gap-1 overflow-x-auto scrollbar-none mr-2">
    {values.length > 0 ? (
      values.slice(0, 3).map((value, idx) => (
        <Badge key={value + String(idx)} variant="secondary" className="text-xs">
          {value}
        </Badge>
      ))
    ) : (
      <Badge variant="secondary" className="text-xs">
        {emptyLabel}
      </Badge>
    )}
    {values.length > 3 && (
      <Badge variant="outline" className="text-xs">
        {`+ ${values.length - 3}`}
      </Badge>
    )}
  </div>
);
